export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const REDIRECT_URL = 'REDIRECT_URL';
